import { FormValidationRules as DefaultFormValidationRules } from '@tangocard/mango'

const FormValidationRules = {
  ...DefaultFormValidationRules,
  min (length, message) {
    return v =>
      (!!v && v.length >= length) ||
      message ||
      `Must be at least ${length} characters`
  },
  hasUppercaseCharacter (message) {
    return v =>
      /(?=.*[A-Z])/.test(v) || message || 'Must have one uppercase character'
  },
  hasSpecialCharacter (message) {
    return v =>
      /([$&+,:;=?@#|'<>.^*()%!-])/.test(v) ||
      message ||
      'Must have one special character'
  },
  hasNumber (message) {
    return v => /(?=.*\d)/.test(v) || message || 'Must have one number'
  }
  // add custom rules, overrides here
}

export default FormValidationRules
